<template>
  <emd-alert
    v-if="show"
    variant="warning"
    class="eu-mb_5"
    no-close
  >
    <template slot="content">
      <p>
        {{ $t('description') }}
      </p>
    </template>
  </emd-alert>
</template>

<script>
import { EmdAlert } from 'emerald-vue/src/components'

export default {
  name: 'AlertTestAccount',

  components: {
    EmdAlert
  },

  props: {
    show: Boolean
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "description": "Estas são as chaves que você precisa para fazer testes na nossa API. Para transações com recebíveis reais, use as chaves do ambiente de Produção."
    },
    "en-US": {
      "description": "These are the keys you need to test our API. For transactions with real receivables, use keys from the Production environment."
    }
  }
</i18n>
